import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { decodeHTML } from "@utils/CommonUtils";
import { useEffect } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useNotification } from "~/Hooks/useNotification";
import { useQuery } from "~/Hooks/useQuery";
import { post, put } from "~/Services";
import { passengerHost } from "~/Utils";
import { fields } from "../constants";
import { useHelpHeadingDocumentDetails } from "./PageHeading.Hooks";
import { useLocalStorage } from "~/Hooks/useLocalStorage";

export const PageHeading = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const { openToast } = useNotification();
  const [currentAirport] = useLocalStorage("currentAirport", null);

  const {
    data: editHelpHeading,
    error,
    isLoading: drilldownLoading,
    isError,
    refetch: refetchCategories,
  } = useHelpHeadingDocumentDetails(query.get("editId") || "");

  const {
    data: editHelpHeadingById,
    isLoading: isLoadingLocs,
    refetch: refetchDocument,
  } = useDocumentDetails(query?.get("id") || "");

  useEffect(() => {
    const activeTab = query.get("activeTab");
    if (activeTab === "pageHeading") {
      refetchCategories();
    }
    if (query.get("id")) {
      refetchDocument();
    }
    if (query.get("editId")) {
      refetchCategories();
    }
  }, [query.get("activeTab"), query.get("editId"), query.get("id")]);

  const formConfig: FormConfig = {
    initialValues: {
      banner_img: editHelpHeadingById?.payload
        ? [
            {
              uid: "-1",
              name: "banner_img.png",
              status: "done",
              url: editHelpHeadingById?.payload?.banner_img,
            },
          ]
        : editHelpHeading?.banner_img
          ? [
              {
                uid: "-1",
                name: "banner_img.png",
                status: "done",
                url: editHelpHeading?.banner_img,
              },
            ]
          : "",

      help_txt: editHelpHeadingById
        ? decodeHTML(editHelpHeadingById.payload?.help_txt)
        : editHelpHeading
          ? decodeHTML(editHelpHeading?.help_txt)
          : "",

      field_help_name_ms: editHelpHeadingById
        ? decodeHTML(editHelpHeadingById.payload?.field_help_name_ms)
        : editHelpHeading
          ? decodeHTML(editHelpHeading?.field_help_name_ms)
          : "",

      field_help_name_zh: editHelpHeadingById
        ? decodeHTML(editHelpHeadingById.payload?.field_help_name_zh)
        : editHelpHeading
          ? decodeHTML(editHelpHeading?.field_help_name_zh)
          : "",

      field_place_txt_en: editHelpHeadingById
        ? decodeHTML(editHelpHeadingById.payload?.field_place_txt_en)
        : editHelpHeading
          ? decodeHTML(editHelpHeading?.field_place_txt_en)
          : "",

      field_place_txt_ms: editHelpHeadingById
        ? decodeHTML(editHelpHeadingById.payload?.field_place_txt_ms)
        : editHelpHeading
          ? decodeHTML(editHelpHeading?.field_place_txt_ms)
          : "",

      field_place_txt_zh: editHelpHeadingById
        ? decodeHTML(editHelpHeadingById.payload?.field_place_txt_zh)
        : editHelpHeading
          ? decodeHTML(editHelpHeading?.field_place_txt_zh)
          : "",

      field_services_txt_en: editHelpHeadingById
        ? decodeHTML(editHelpHeadingById.payload?.field_services_txt_en)
        : editHelpHeading
          ? decodeHTML(editHelpHeading?.field_services_txt_en)
          : "",

      field_services_txt_ms: editHelpHeadingById
        ? decodeHTML(editHelpHeadingById.payload?.field_services_txt_ms)
        : editHelpHeading
          ? decodeHTML(editHelpHeading?.field_services_txt_ms)
          : "",

      field_services_txt_zh: editHelpHeadingById
        ? decodeHTML(editHelpHeadingById.payload?.field_services_txt_zh)
        : editHelpHeading
          ? decodeHTML(editHelpHeading?.field_services_txt_zh)
          : "",

      field_support_txt_en: editHelpHeadingById
        ? decodeHTML(editHelpHeadingById.payload?.field_support_txt_en)
        : editHelpHeading
          ? decodeHTML(editHelpHeading?.field_support_txt_en)
          : "",

      field_support_txt_ms: editHelpHeadingById
        ? decodeHTML(editHelpHeadingById.payload?.field_support_txt_ms)
        : editHelpHeading
          ? decodeHTML(editHelpHeading?.field_support_txt_ms)
          : "",

      field_support_txt_zh: editHelpHeadingById
        ? decodeHTML(editHelpHeadingById.payload?.field_support_txt_zh)
        : editHelpHeading
          ? decodeHTML(editHelpHeading?.field_support_txt_zh)
          : "",

      field_card_name_en: editHelpHeadingById
        ? decodeHTML(editHelpHeadingById.payload?.field_card_name_en)
        : editHelpHeading
          ? decodeHTML(editHelpHeading?.field_card_name_en)
          : "",

      field_card_name_ms: editHelpHeadingById
        ? decodeHTML(editHelpHeadingById.payload?.field_card_name_ms)
        : editHelpHeading
          ? decodeHTML(editHelpHeading?.field_card_name_ms)
          : "",

      field_card_name_zh: editHelpHeadingById
        ? decodeHTML(editHelpHeadingById.payload?.field_card_name_zh)
        : editHelpHeading
          ? decodeHTML(editHelpHeading?.field_card_name_zh)
          : "",

      field_card_redirect_url_en: editHelpHeadingById
        ? decodeHTML(editHelpHeadingById.payload?.field_card_redirect_url_en)
        : editHelpHeading
          ? decodeHTML(editHelpHeading?.field_card_redirect_url_en)
          : "",

      field_card_redirect_url_ms: editHelpHeadingById
        ? decodeHTML(editHelpHeadingById.payload?.field_card_redirect_url_ms)
        : editHelpHeading
          ? decodeHTML(editHelpHeading?.field_card_redirect_url_ms)
          : "",

      field_card_redirect_url_zh: editHelpHeadingById
        ? decodeHTML(editHelpHeadingById.payload?.field_card_redirect_url_zh)
        : editHelpHeading
          ? decodeHTML(editHelpHeading?.field_card_redirect_url_zh)
          : "",

      published: editHelpHeadingById
        ? Boolean(editHelpHeadingById.payload?.published)
        : editHelpHeading
          ? Boolean(editHelpHeading?.published)
          : false,
    },

    fields: fields.pageHeading,
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    console.log("data-123", data);

    let imageKeys: any = ["banner_img"];
    for (const key of imageKeys) {
      const field = data[key];

      try {
        if (field?.[0]?.originFileObj) {
          const formData = new FormData();
          formData.append("upload-file", field[0].originFileObj);
          formData.append("application", "PASSENGER");
          const res: any = await post("management/upload-file", formData);
          if (res) data[key] = res.response.data;
        } else if (field?.[0]?.url) {
          data[key] = field[0].url;
        } else if (Array.isArray(field) && field.length === 0) {
          data[key] = "";
        } else if (!field) {
          data[key] = "";
        }
      } catch (error) {
        console.error(`Error handling image field ${key}:`, error);
      }
    }

    const payload = {
      action,
      method,
      module: "Help",
      subModule: "pageHeading",
      airportName: currentAirport,
      type: "DEDICATED",
      application: "PASSENGER_ECMS",
      reviewNotes,
      appList: [
        {
          appName: "PASSENGER_ECMS",
          apiUrl,
        },
      ],
      payload: {
        ...(action === "UPDATE" && {
          id: editHelpHeading?.id || editHelpHeadingById?.payload?.id,
        }),
        ...data,
      },
      status,
    };

    console.log("Final Payload:", payload);

    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response: any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch(() => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post(`/management/publish`, payload)
        .then((response: any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch(() => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  return (
    <>
      <DynamicForm
        isLoading={drilldownLoading || isLoadingLocs}
        config={formConfig}
        onSubmit={(data, buttonValue, reviewNotes) =>
          onSubmit(
            data,
            `${passengerHost}/api/get-help-banner-images-crud-api-data/${editHelpHeading?.id || editHelpHeadingById?.payload?.id}`,
            "UPDATE",
            "PATCH",
            buttonValue === "save" ? "DRAFT" : "PENDING",
            reviewNotes
          )
        }
        defaultReviewNotes="Kindly review this Help"
      />
    </>
  );
};
